module.exports = __webpack_public_path__ + "static/programmingwithjon2-7c7139e4adc858a145980406b0e11a22.png";